import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';
import { RestoreBackupDialogData } from '@app/shared/components/dialogs/restore-backup-dialog/restore-backup-dialog.data';

@Component({
    selector : 'restore-backup-dialog',
    template: require('./restore-backup-dialog.component.html'),
    styles: [require('./restore-backup-dialog.component.scss')]
})
export class RestoreBackupDialogComponent {
    constructor(@Inject(MAT_DIALOG_DATA) public data: RestoreBackupDialogData) {
    }

    public isBackupSelected: boolean = false;
    public isRestoreDeployedPackagesOnlyMandatory: boolean = false;

    public onSelect(event, data) {
        this.isBackupSelected = true;
        
        //console.log(event);

        if (event.source.value.backupDeployedPackagesOnly) {
            this.isRestoreDeployedPackagesOnlyMandatory = true;
            data.restoreDeployedPackagesOnly = true;
        } else {
            this.isRestoreDeployedPackagesOnlyMandatory = false;
            data.restoreDeployedPackagesOnly = false;
        }
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/components/dialogs/restore-backup-dialog/restore-backup-dialog.component.ts